module.exports = __webpack_public_path__ + "static/img/login-bg.54dd61a2.jpg";